import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthorizationContainerComponent } from '../authorization-container/authorization-container.component';
import { MatIcon } from '@angular/material/icon';
import { APP_PATHS } from '@core/constants';
import { FilledButtonComponent } from '@custom-components/general/button/filled-button/filled-button.component';
import { TextButtonComponent } from '@custom-components/general/button/text-button/text-button.component';

@Component({
  selector: 'xemex-link-expired-page',
  imports: [
    MatIcon,
    TranslateModule,
    AuthorizationContainerComponent,
    FilledButtonComponent,
    TextButtonComponent,
  ],
  templateUrl: './link-expired-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './link-expired-page.component.scss',
})
export class LinkExpiredPageComponent {
  private readonly router = inject(Router);

  requestNewLink() {
    this.router.navigate(['/', APP_PATHS.Auth, APP_PATHS.ResetPassword]);
  }

  backToLogin() {
    this.router.navigate(['/', APP_PATHS.Auth, APP_PATHS.Login]);
  }
}
